import { Box, styled, alpha } from "@mui/material";

export const StyledAccount = styled(Box)(({ theme: { spacing, palette } }) => ({
  padding: spacing(2),

  "& .MuiButton-root": {
    justifyContent: "start",
    background: palette.main[900],
    padding: 12,
    textTransform: "none",

    "&:hover": {
      background: palette.main[800],
    },

    "& .MuiButton-startIcon": {
      "& .MuiSvgIcon-root": {
        width: 32,
        height: 32,
      },
    },

    "& .MuiTypography-caption": {
      color: alpha(palette.common.white, 0.6),
    },

    "& .MuiTypography-body1": {
      color: palette.common.white,
    },
  },
}));
